import { Check, Lock } from "lucide-react";
import { FadeUp } from "./FadeUp";

const ROWS = [
  { label: "AI Diet Plan", free: true, pro: true, coaching: true },
  { label: "Meal & Water Tracker", free: true, pro: true, coaching: true },
  { label: "View Workout Plan", free: true, pro: true, coaching: true },
  { label: "Community Feed", free: true, pro: true, coaching: true },
  { label: "Meal Swaps", free: "3/week", pro: "Unlimited", coaching: "Unlimited" },
  { label: "Gym Workout Logger", free: false, pro: true, coaching: true },
  { label: "AI Physique Check-ins", free: false, pro: true, coaching: true },
  { label: "Progress Reports + PDF", free: false, pro: true, coaching: true },
  { label: "Recipes & Grocery List", free: false, pro: true, coaching: true },
  { label: "Chat with Coach Arjun", free: false, pro: false, coaching: true },
  { label: "1:1 Video Calls", free: false, pro: false, coaching: "2/month" },
  { label: "Plan Updated by Coach", free: false, pro: false, coaching: true },
];

const Cell = ({ value }) => {
  if (value === true) return <Check size={17} className="text-[#C6FF3D]" />;
  if (value === false) return <Lock size={14} className="text-[#55555a]" />;
  return <span className="text-[#C6FF3D] text-xs font-semibold">{value}</span>;
};

export const PlanComparisonTable = () => (
  <FadeUp>
    <div className="overflow-x-auto rounded-[24px] border border-[#232326]" data-testid="plan-comparison-table">
      <table className="w-full min-w-[520px] text-sm">
        <thead>
          <tr className="bg-[#141416]">
            <th className="text-left text-[#A1A1AA] font-medium px-5 py-4">Feature</th>
            <th className="text-center text-white font-medium px-5 py-4">Free</th>
            <th className="text-center text-[#C6FF3D] font-display text-base px-5 py-4">Pro</th>
            <th className="text-center text-white font-medium px-5 py-4">Coaching</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((row, i) => (
            <tr key={row.label} className={i % 2 === 0 ? "bg-[#0A0A0B]" : "bg-[#0d0d0f]"}>
              <td className="text-white px-5 py-3.5">{row.label}</td>
              <td className="text-center px-5 py-3.5">
                <div className="flex justify-center">
                  <Cell value={row.free} />
                </div>
              </td>
              <td className="text-center px-5 py-3.5">
                <div className="flex justify-center">
                  <Cell value={row.pro} />
                </div>
              </td>
              <td className="text-center px-5 py-3.5">
                <div className="flex justify-center">
                  <Cell value={row.coaching} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </FadeUp>
);
